export const UnitTypes = {
  Pallet: 'Pallet',
  Unit: 'Unit',
  Kg: 'Kg',
  Day: 'Day',
  Hour: 'Hour',
  Mile: 'Mile',
  FTL: 'FTL',
} as const;

export type UnitType = (typeof UnitTypes)[keyof typeof UnitTypes];

// Map a pallet-type label (as displayed in the form) to the canonical unit type
// the rate-card engine uses. Pallet variants → "Pallet"; non-pallet shipments →
// "Unit" so non-pallet rate cards still match.
export function deriveUnitType(
  palletType: string | undefined | null
): UnitType {
  if (!palletType) return UnitTypes.Pallet;
  const normalized = palletType.toLowerCase();
  if (normalized === 'unpalletised' || normalized === 'other') {
    return UnitTypes.Unit;
  }
  return UnitTypes.Pallet;
}
